<template>
  <el-dialog title="修改实践活动" :visible="isEditPracticalActivityShow" @open="dialogOpen" @close="dialogClose"
    :close-on-click-modal="false" width="600px">
    <div class="editactivity-form">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="活动名称" label-width="120px" prop="activityName">
          <el-input v-model="ruleForm.activityName" autocomplete="off" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="活动时间" label-width="120px" prop="activityDate">
          <el-date-picker v-model="ruleForm.activityDate" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="学年:" label-width="120px" prop="schoolYear">
          <year-range-picker style="width: 250px;" v-model="ruleForm.schoolYear" />
        </el-form-item>
        <el-form-item label="学期:" label-width="120px" prop="semester">
          <el-select v-model="ruleForm.semester" placeholder="请选择学期" style="width: 235px">
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成绩录入时效" label-width="120px" prop="recordTime">
          <el-date-picker v-model="ruleForm.recordTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="年级班级" label-width="100px" prop="classData">
          <el-cascader
            class="student-search"
            v-model="ruleForm.className"
            placeholder="选择"
            :props="classProps"
            :options="classSelect"
            @change="changeHandle"
          ></el-cascader>
        </el-form-item> -->
      </el-form>
      <div class="form-btn">
        <!-- <el-button @click="dialogClose">取 消</el-button> -->
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      ruleForm: {
        activityDate: "",
        activityName: "",
        recordTime: "",
        schoolYear: "",
        semester: "",
      },
      rules: {
        activityName: [
          { required: true, message: "请选择活动名称", trigger: "change" },
        ],
        recordTime: [{ required: true, message: "请选择日期", trigger: "change" }],
        activityDate: [{ required: true, message: "请选择日期", trigger: "change" }],
        schoolYear: [{ required: true, message: "请选择学年", trigger: "change" }],
        semester: [{ required: true, message: "请选择学期", trigger: "change" }],
        // classData: [
        //   { required: true, message: "请选择年级班级", trigger: "change" },
        // ],
      },
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
    };
  },
  props: {
    isEditPracticalActivityShow: {
      type: Boolean,
      default: false,
    },
    practicalActivityData: {
      type: Object,
    },
    classSelect: {
      type: Array,
    },
    semesterOptions: {
      type: Array,
    },
  },
  inject: ["refresh"],
  methods: {
    confirm() {
      let { activityName, activityDate, recordTime } = this.ruleForm;
      this.put(this.$url.editPracticalActivity, {
        id: this.practicalActivityData.id,
        activityName,
        startTime: activityDate[0], //活动开始时间 可选
        endTime: activityDate[1], //活动结束时间 可选
        recordStartTime: recordTime[0],
        recordEndTime: recordTime[1]
      }).then((res) => {
        // console.log(res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success("修改成功");
        this.dialogClose();
        this.refresh();
      });
    },
    // 选择班级
    // changeHandle(e) {
    //   // console.log("选中的班级==>", e);
    //   this.ruleForm.gradeId = e[0].gradeId;
    //   this.ruleForm.classId = e[1].classId;
    // },
    dialogOpen() {
      this.reset();
      let { activityName, startTime, endTime, recordEndTime, recordStartTime, schoolYear, semester } = this.practicalActivityData;
      this.ruleForm.activityName = activityName;
      this.ruleForm.schoolYear = schoolYear;
      this.ruleForm.semester = semester;
      if (recordStartTime && recordEndTime) {
        this.ruleForm.recordTime = [recordStartTime, recordEndTime];
      };
      if (startTime && endTime) {
        this.ruleForm.activityDate = [startTime, endTime];
      };
    },
    dialogClose() {
      this.$emit("update:isEditPracticalActivityShow", false);
    },
    reset() {
      this.ruleForm = {
        activityDate: "",
        activityName: "",
        recordTime: ""
      };
      // this.$refs["ruleForm"].clearValidate(); //移除表单检验结果
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./practicalActivityEdit.scss";
</style>